import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../../../actions/CauHinhGoiTraGop";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import userApi from "../../../../../service/userApi";
import NguonVonApi from "../../../../../service/nguonVonApi";
import BanHangTraGopApi from "service/banHangTraGopApi";
import { formatMoney } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { BtnKhoa } from "./ChucNang/Khoa/BtnKhoa";
import { BtnMoKhoa } from "./ChucNang/MoKhoa/BtnMoKhoa";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { formatNumber } from "utils/currencyFormat";
export const ModalChiTiet = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    Id: 0,
    IdSanPham: props.Id,
    GiaGoc: 0,
    GiaTraGop: 0,
    KyHan: 0,
    PhanTramTraTruoc: 0,
    TrangThai: true,
  };
  const [dataGoiSanPham, setDataGoiSanPham] = useState(initData);

  const GiaGoc = React.createRef();
  const GiaTraGop = React.createRef();
  const KyHan = React.createRef();
  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataGoiSanPham({
      ...dataGoiSanPham,
      [field]: e.target.value,
    });
    if (field === "PhanTramTraTruoc") {
      if (convertToNumber(e.target.value) > 100) {
        setDataGoiSanPham({
          ...dataGoiSanPham,
          [field]: 0,
        });
      } else {
        setDataGoiSanPham({
          ...dataGoiSanPham,
          [field]: e.target.value,
        });
      }
    }
    if (field === "GiaGoc") {
      if (e.target.value === 0) {
        GiaGoc.current.focus();
        setErrors({
          ...errors,
          GiaGoc: "Vui lòng nhập giá sản phẩm",
        });
      } else {
        setErrors({
          ...errors,
          GiaGoc: "",
        });
      }
    } else if (field === "GiaTraGop") {
      if (e.target.value === 0) {
        GiaTraGop.current.focus();
        setErrors1({
          ...errors1,
          GiaTraGop: "Vui lòng nhập giá bán trả góp",
        });
      } else {
        setErrors1({
          ...errors1,
          GiaTraGop: "",
        });
      }
    } else if (field === "KyHan") {
      if (e.target.value === 0) {
        KyHan.current.focus();
        setErrors2({
          ...errors2,
          KyHan: "Vui lòng nhập kỳ hạn",
        });
      } else {
        setErrors2({
          ...errors2,
          KyHan: "",
        });
      }
    }
  };

  useEffect(() => {
    // if (props.customerId > 0) {
    //   NguonVonApi.chiTietNguonVon(props.customerId).then((response) => {
    //     //
    //   });
    // }
  }, []);

  //Thông báo
  const validateName = (nguoinop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(nguoinop).toLowerCase());
  };

  const initErrors = {
    GiaGoc: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    GiaTraGop: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    KyHan: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);

  const onSubmit = () => {
    const value = { ...dataGoiSanPham };
    if (value.GiaGoc === 0) {
      setErrors({
        ...errors,
        GiaGoc: "Vui lòng nhập giá sản phẩm",
      });
      return;
    } else if (value.GiaTraGop === 0) {
      setErrors1({
        ...errors1,
        GiaTraGop: "Vui lòng nhập giá bán trả góp",
      });
      return;
    } else if (value.KyHan === 0) {
      setErrors2({
        ...errors2,
        KyHan: "Vui lòng nhập kỳ hạn",
      });
      return;
    } else if (
      convertToNumber(value.GiaTraGop) < convertToNumber(value.GiaGoc)
    ) {
      setErrors1({
        ...errors1,
        GiaTraGop: "Giá bán trả góp phải lớn hơn giá sản phẩm",
      });
      return;
    }
    if (idEdit > 0) {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiSanPham(params).then((response) => {
        console.log(response, "thêm mới gói");
        if (response.status == 200) {
          setIdEdit(0);
          pushNotification(
            "Cập nhật gói sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
          setDataGoiSanPham(initData);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
        console.log(response, "aaaaaaaaaaaaaaaa");
      });
    } else {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiSanPham(params).then((response) => {
        console.log(response, "thêm mới gói");
        if (response.status == 200) {
          pushNotification(
            "Thêm gói sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
          setDataGoiSanPham(initData);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
        console.log(response, "aaaaaaaaaaaaaaaa");
      });
    }
  };
  const [idEdit, setIdEdit] = useState(0);
  const handleEdit = (item) => () => {
    console.log(item, "aaaaaaa");
    if (item.Id > 0) {
      setIdEdit(item.Id);
      setDataGoiSanPham({
        ...dataGoiSanPham,
        Id: item.Id,
        IdSanPham: props.Id,
        GiaGoc: item.GiaGoc,
        GiaTraGop: item.GiaTraGop,
        KyHan: item.KyHan,
        PhanTramTraTruoc: item.PhanTramTraTruoc,
        TrangThai: true,
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>{" "}
          <span> Chi tiết sản phẩm</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body row">
            <div className="col-lg-2">
              <div className="form-group">
                <label className=" label-control text-left color7-bold">
                  Giá sản phẩm
                </label>

                <input
                  type="text"
                  className="form-control input-sm text-right"
                  value={formatMoney(dataGoiSanPham.GiaGoc)}
                  onChange={updateTextValue("GiaGoc")}
                  name="GiaGoc"
                  placeholder="0"
                  ref={GiaGoc}
                />
              </div>
              {errors.GiaGoc && (
                <div className="form-group row">
                  <div className="col-md-12">
                    <span
                      className="canh-bao-red"
                      style={{ marginBottom: "10px" }}
                    >
                      {errors.GiaGoc}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-2">
              <div className="form-group">
                <label className=" label-control text-left  color7-bold">
                  Giá bán trả góp
                </label>

                <input
                  type="text"
                  className="form-control input-sm text-right"
                  value={formatMoney(dataGoiSanPham.GiaTraGop)}
                  onChange={updateTextValue("GiaTraGop")}
                  name="GiaTraGop"
                  placeholder="0"
                  ref={GiaTraGop}
                />
              </div>
              {errors1.GiaTraGop && (
                <div className="form-group row">
                  <div className="col-md-12">
                    <span
                      className="canh-bao-red"
                      style={{ marginBottom: "10px" }}
                    >
                      {errors1.GiaTraGop}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-2">
              <div className="form-group">
                <label className=" label-control text-left  color7-bold">
                  Trả trước
                </label>

                <input
                  type="text"
                  className="form-control input-sm text-right"
                  value={formatMoney(dataGoiSanPham.PhanTramTraTruoc)}
                  onChange={updateTextValue("PhanTramTraTruoc")}
                  name="PhanTramTraTruoc"
                  placeholder="%"
                />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="form-group">
                <label className=" label-control text-left  color7-bold">
                  Kỳ hạn
                </label>

                <input
                  type="text"
                  className="form-control input-sm text-right"
                  value={formatMoney(dataGoiSanPham.KyHan)}
                  onChange={updateTextValue("KyHan")}
                  name="KyHan"
                  placeholder="Tháng"
                  ref={KyHan}
                />
              </div>
              {errors2.KyHan && (
                <div className="form-group row">
                  <div className="col-md-12">
                    <span
                      className="canh-bao-red"
                      style={{ marginBottom: "10px" }}
                    >
                      {errors2.KyHan}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-4">
              <a
                className="btn btn-new-main btn-checknew"
                href={() => false}
                onClick={onSubmit}
                style={{ marginTop: "15px" }}
              >
                <span>
                  <i class="mdi mdi-plus"></i>
                </span>{" "}
                &nbsp; {idEdit === 0 ? "Thêm gói" : "Cập nhật"}&nbsp;
              </a>
            </div>
            <div className="col-lg-12">
              <div
                id="collapse25324"
                aria-labelledby="headingCollapse25324"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="table-responsive table-2">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>STT</th>
                            <th>Số kỳ hạn</th>
                            <th>Trả trước</th>
                            <th className="text-right">Giá sản phẩm</th>
                            <th className="text-right">Giá bán trả góp</th>
                            <th className="text-right">Chênh lệch</th>
                            <th>Trạng thái</th>
                            <th>Thao tác</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.item.lstGoi.length > 0 &&
                            props.item.lstGoi.map((item, index) => (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{formatNumber(item.KyHan)}</td>
                                <td>{formatNumber(item.PhanTramTraTruoc)}</td>
                                <td className="text-right">
                                  {formatNumber(item.GiaGoc)}
                                </td>
                                <td className="text-right">
                                  {formatNumber(item.GiaTraGop)}
                                </td>
                                <td className="text-right">
                                  {formatNumber(item.GiaTraGop - item.GiaGoc)}
                                </td>
                                <td>
                                  {item.TrangThai === true
                                    ? "Đang sử dụng"
                                    : "Tạm khoá"}
                                </td>
                                <td>
                                  <a
                                    href={() => false}
                                    onClick={handleEdit(item)}
                                  >
                                    <PopoversBootrap
                                      contentText="Sửa"
                                      titleText=""
                                      trigger={["hover", "focus"]}
                                      placement={"top"}
                                    >
                                          <img src="/app-assets/images/icon-edit-v2.png" />
                                    </PopoversBootrap>
                                  </a>
                                  {item.TrangThai === true ? (
                                    <BtnKhoa item={item} />
                                  ) : (
                                    <BtnMoKhoa item={item} />
                                  )}

                                  <BtnXoa item={item} />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
